module.exports = __webpack_public_path__ + "img/banner_king@2x.8ecedbab.png";